import { render, staticRenderFns } from "./preservation.vue?vue&type=template&id=7a312cc8&scoped=true&"
import script from "./preservation.vue?vue&type=script&lang=js&"
export * from "./preservation.vue?vue&type=script&lang=js&"
import style0 from "./preservation.vue?vue&type=style&index=0&id=7a312cc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a312cc8",
  null
  
)

export default component.exports